export const APP_CONFIG = global.APP_CONFIG || {};
export let REACT_APP_API_URL = global.APP_CONFIG?.REACT_APP_API_URL;
export let PCO_CLIENT_ID = global.APP_CONFIG?.PCO_CLIENT_ID;
export let MC_CLIENT_ID = global.APP_CONFIG?.MC_CLIENT_ID;
export let REACT_APP_UI_URL = global.APP_CONFIG?.REACT_APP_UI_URL;
export let REACT_APP_VIDEO_DOMAIN = global.APP_CONFIG?.REACT_APP_VIDEO_DOMAIN;
export let REACT_APP_STRIPE_PUB_KEY =
  global.APP_CONFIG?.REACT_APP_STRIPE_PUB_KEY;
export let LOCIZE_API_KEY = global.APP_CONFIG?.LOCIZE_API_KEY;
export let LOCIZE_PROJECT_ID = global.APP_CONFIG?.LOCIZE_PROJECT_ID;
export let LOCIZE_VERSION = global.APP_CONFIG?.LOCIZE_VERSION;
export let BRAND = global.APP_CONFIG?.BRAND;
export let STAGE = global.APP_CONFIG?.STAGE;
export let WEBSITE =
  BRAND === 'TMG' ? 'https://textmygym.com' : 'https://textinchurch.com';

export const init = (config) => {
  if (!config) return;

  REACT_APP_API_URL = config.REACT_APP_API_URL;
  PCO_CLIENT_ID = config.PCO_CLIENT_ID;
  MC_CLIENT_ID = config.MC_CLIENT_ID;
  REACT_APP_UI_URL = config.REACT_APP_UI_URL;
  REACT_APP_VIDEO_DOMAIN = config.REACT_APP_VIDEO_DOMAIN;
  REACT_APP_STRIPE_PUB_KEY = config.REACT_APP_STRIPE_PUB_KEY;
  LOCIZE_API_KEY = config.LOCIZE_API_KEY;
  LOCIZE_PROJECT_ID = config.LOCIZE_PROJECT_ID;
  LOCIZE_VERSION = config.LOCIZE_VERSION;
  BRAND = config.BRAND;
  WEBSITE =
    config.BRAND === 'TMG'
      ? 'https://textmygym.com'
      : 'https://textinchurch.com';
  STAGE = config.STAGE;
};

if (typeof window !== 'undefined') {
  init(window.APP_CONFIG);
}
